import React, { useEffect, useState } from "react";
import HeadingBanner from "../components/HeadingBanner";
import AssessmentClassCard from "../components/AssessmentClassCard";
import LeftPanel from "../components/LeftPanel";
import AlpacaInfoGesture from "../components/AlpacaInfoGesture";
import ClassFilter from "../components/ClassFilter";
import { useNavigate, Link } from "react-router-dom";
import {
  whoami,
  getClasses,
  getTeachers,
  getSchools,
  getCountryGrades,
  getTrialistsBySchool,
  updateTrialistStartDate,
  getCountryId,
  getPilotBySchoolId,
  getScreeningWindowStatuses,
  getPurchasesBySchool
} from "../services/APIClient";
import { Container, Row, Col, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "../components/AssessmentClassCard.css";
import OrientationPrompt from "../components/OrientationPrompt";
import FreeTrialBanner from "../components/FreeTrialBanner";
import { LATEST_PURCHASE_FILTER } from "../utils/screenerAccess";
const VideoModal = React.lazy(() =>
  import("../components/VideoModal")
);

function AssessmentsDashboard() {
  const [schoolid, setSchoolid] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("");
  const [teachers, setTeachers] = useState(null);
  const [firstname, setFirstname] = useState(null);
  const [speechText, setSpeechText] = useState(null);
  const [classes, setClasses] = useState([]);
  const [rollNumber, setRollNumber] = useState(null);
  const [filteredClasses, setFilteredClasses] = useState([]);
  const [gradeLevelOptions, setGradeLevelOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [teacherRoles, setTeacherRoles] = useState(null);
  const [trialistDetails, setTrialistDetails] = useState(null);
  const [freeDaysLeft, setFreeDaysLeft] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showStartTrialModal, setShowStartTrialModal] = useState(false);
  const [countryId, setCountryId] = useState(null);

  const [existingConversionMethods, setExistingConversionMethods] = useState([]);
  const [pilotData, setPilotData] = useState(null);
  const [screeningWindowData, setScreeningWindowData] = useState(null);
  const [latestPurchase, setLatestPurchase] = useState(null);
  const [trialistLoading, setTrialistLoading] = useState(true);
  const [pilotLoading, setPilotLoading] = useState(true);
  const [purchaseLoading, setPurchaseLoading] = useState(true);
  const [purchaseError, setPurchaseError] = useState(false);
  const DEFAULT_COUNTRY_ID = '07d45b79-24b1-435f-b82a-93861b23a86e';
  const isPilot = pilotData && pilotData.length > 0 && pilotData[0].active;

  const now = new Date();


  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  const buttonStyle = {
    // width: '80%',
    padding: '16px 24px',
    fontSize: '2.5vh',
    fontWeight: '600',
    backgroundColor: '#FF6B35',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)',
    transition: 'none',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    outline: 'none',
    marginBottom: '1%',
    width: '100%'
  };

  // function inputInterpreter(){


  // }

  const navigate = useNavigate();

  useEffect(() => {
    whoami().then((response) => {
      setSchoolid(response.data.stakeholder.schoolid);
      setTeacherid(response.data.stakeholder.id);
      setName(response.data.stakeholder.name);
      setTeacherRoles(response.data.stakeholder.additionalRoles);
    });
  }, []);

  // useEffect(() => {
  //   async function fetchSchoolData() {
  //     try {
  //       const teachersResponse = await getTeachers(schoolid);
  //       setTeachers(teachersResponse);

  //       let classesResponse = await getClasses();

  //       // Remove duplicate classes based on their id
  //       classesResponse = classesResponse.filter(
  //         (classItem, index, self) =>
  //           index === self.findIndex((t) => t.id === classItem.id)
  //       );

  //       // Sort classes by the date_created field in descending order
  //       classesResponse.sort(
  //         (a, b) => new Date(b.date_created) - new Date(a.date_created)
  //       );
  //       setClasses(classesResponse);

  //       const schoolsResponse = await getSchools();
  //       const matchingSchool = schoolsResponse.data.find(
  //         (school) => school.id === schoolid
  //       );

  //       if (matchingSchool) {
  //         const rollNumber = matchingSchool.rollnumber;
  //         const countryid = matchingSchool.countryid;
  //         setCountryId(countryid);
  //         setRollNumber(rollNumber);

  //         getCountryGrades(countryid)
  //           .then((gradesResponse) => {
  //             setGradeLevelOptions([gradesResponse]);
  //           })
  //           .catch((error) => {
  //             console.error("Error fetching country grades:", error);
  //           });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching school data:", error);
  //     }
  //   }

  //   if (schoolid) {
  //     fetchSchoolData().finally(() => {
  //       setLoading(false);
  //     });
  //   }
  // }, [schoolid]);

  useEffect(() => {
    async function fetchSchoolData() {
      try {
        const teachersResponse = await getTeachers(schoolid);
        setTeachers(teachersResponse);

        let classesResponse = await getClasses();

        // Remove duplicate classes based on their id
        classesResponse = classesResponse.filter(
          (classItem, index, self) =>
            index === self.findIndex((t) => t.id === classItem.id)
        );

        // Sort classes by the date_created field in descending order
        classesResponse.sort(
          (a, b) => new Date(b.date_created) - new Date(a.date_created)
        );
        setClasses(classesResponse);

        // Get country ID using the new API
        const countryResponse = await getCountryId(schoolid);

        if (countryResponse.countryId) {
          setCountryId(countryResponse.countryId);

          // Fetch country grades using the country ID
          const gradesResponse = await getCountryGrades(countryResponse.countryId);
          setGradeLevelOptions([gradesResponse]);
        } else {
          console.warn("No country ID found for school:", countryResponse.message);
          setCountryId(null);
        }

        // Still need to get roll number - keeping this part of the schools call
        const schoolsResponse = await getSchools();
        const matchingSchool = schoolsResponse.data.find(
          (school) => school.id === schoolid
        );

        if (matchingSchool) {
          setRollNumber(matchingSchool.rollnumber);
        }

      } catch (error) {
        console.error("Error fetching school data:", error);
        setCountryId(null);
      }
    }

    if (schoolid) {
      fetchSchoolData().finally(() => {
        setLoading(false);
      });
    }
  }, [schoolid]);

  useEffect(() => {
    if (name) {
      const nameArray = name.split(" ");
      setFirstname(nameArray[0]);
    }
  }, [name, schoolid]);

  useEffect(() => {
    setSpeechText(
      `Whoa slow down there ${firstname}. We need to create a class first. Click into "Classrooms" on the left to get this started`
    );
  }, [firstname]);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    window.HubSpotConversations?.widget?.refresh();
  }, []);

  useEffect(() => {
    const fetchTrialistDetails = async () => {
      if (!schoolid) return;

      setTrialistLoading(true);
      try {
        const response = await getTrialistsBySchool(schoolid);
        if (response.length > 0) {
          const details = response[0];
          setTrialistDetails(details);

          // Check if the trial has not started AND user hasn't purchased
          const hasPurchased = details.purchased || details.purchased_2425 || details.purchased_2526;

          if (!isPilot && !hasPurchased && (!details.start_selected || new Date(details.start_date) > new Date())) {
            setShowStartTrialModal(true);
          }

          // Calculate freeDaysLeft
          const currentDate = new Date();
          const endDate = new Date(details.end_date);
          const timeDiff = endDate - currentDate;
          const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
          setFreeDaysLeft(daysLeft > 0 ? daysLeft : 0);
        }
      } catch (error) {
        console.error("Failed to fetch trialist details:", error);
      } finally {
        setTrialistLoading(false);
      }
    };
    fetchTrialistDetails();
  }, [schoolid, isPilot]);

  useEffect(() => {
    const fetchLatestPurchase = async () => {
      if (!schoolid) return;

      setPurchaseLoading(true);
      setPurchaseError(false);
      try {
        const purchaseResponse = await getPurchasesBySchool(
          schoolid,
          LATEST_PURCHASE_FILTER
        );

        setLatestPurchase(
          Array.isArray(purchaseResponse) && purchaseResponse.length > 0
            ? purchaseResponse[0]
            : null
        );
      } catch (error) {
        console.error("Error fetching purchase data:", error);
        setLatestPurchase(null);
        setPurchaseError(true);
      } finally {
        setPurchaseLoading(false);
      }
    };

    fetchLatestPurchase();
  }, [schoolid]);

  const handleStartTrial = async () => {
    try {
      await updateTrialistStartDate(schoolid, selectedDate.toISOString());
      setShowStartTrialModal(false);
      alert("Trial start date has been updated. Refresh to see changes.");
    } catch (error) {
      console.error("Failed to set trial start date:", error);
    }
  };

  const { expired = false, start_selected = true, start_date } =
    trialistDetails || {};

  const hasValidPurchaseDate = latestPurchase?.next_payment_date
    ? new Date(latestPurchase.next_payment_date) > now
    : false;
  const isAccessRestricted = expired && !hasValidPurchaseDate && !isPilot;

  const isJIOnlyTrial = !!trialistDetails
    && !trialistDetails.purchased
    && !trialistDetails.purchased_2425
    && !trialistDetails.purchased_2526
    && !trialistDetails.purchased_2627
    && !latestPurchase
    && !isPilot;

  const currentDate = new Date();
  const trialStartDate = start_date ? new Date(start_date) : null;
  const isTrialActive =
    start_selected && trialStartDate && trialStartDate <= currentDate;


  useEffect(() => {
    console.log('🚀 fetchPilotAndScreeningData useEffect triggered');
    console.log('📍 Current values:', { schoolid, countryId });

    const fetchPilotAndScreeningData = async () => {
      if (!schoolid || !countryId) {
        console.log('❌ Missing required values, returning early:', { schoolid, countryId });
        return;
      }

      setPilotLoading(true);
      try {
        // Fetch pilot data
        console.log('🔍 Fetching pilot data for schoolid:', schoolid);
        const pilotResponse = await getPilotBySchoolId(schoolid);
        console.log('📊 Pilot data:', pilotResponse);
        setPilotData(pilotResponse);

        // Fetch screening window status
        console.log('🔍 Fetching screening window for countryid:', countryId);

        let screeningResponse = await getScreeningWindowStatuses({
          countryid: countryId,
          active: true
        });

        console.log('📊 Screening window data (original):', screeningResponse);

        // If no results, fallback to default
        if (!screeningResponse || screeningResponse.length === 0) {
          console.log('⚠️ Using default countryid:', DEFAULT_COUNTRY_ID);
          screeningResponse = await getScreeningWindowStatuses({
            countryid: DEFAULT_COUNTRY_ID,
            active: true
          });
          console.log('📊 Screening window data (default):', screeningResponse);
        }

        setScreeningWindowData(screeningResponse);

      } catch (error) {
        console.error('❌ Error fetching pilot/screening data:', error);
      } finally {
        setPilotLoading(false);
      }
    };

    fetchPilotAndScreeningData();
  }, [schoolid, countryId]);


  return (
    <div>
      <Container fluid className="vh-100">
        <HeadingBanner
          name={`${name}'s Screener`}
          isLoggedIn={true}
          cloud={true}
          schoolid={schoolid}
          teacherid={teacherid}
          pilotData={pilotData}
          screeningWindowData={screeningWindowData}
        />

        <Row className="h-100">
          <LeftPanel />
          <Col sm={{ span: 10, offset: 2 }} className="blue-background">
            {loading ||
            trialistLoading ||
            (countryId && pilotLoading) ||
            purchaseLoading ? (
              <div className="spinner-container">
                <div className="big-ball-spinner"></div>
              </div>
            ) : (
              <>
                <Row className="row-position">
                  <FreeTrialBanner
                    schoolid={schoolid}
                    teacherName={name}
                    freeDaysLeft={freeDaysLeft}
                    trialistDetails={trialistDetails}
                    pilotData={pilotData}
                  />
                  <Col xs={8}>
                    <ClassFilter
                      classes={classes}
                      setFilteredClasses={setFilteredClasses}
                      gradeLevelOptions={gradeLevelOptions}
                      teacherRoles={teacherRoles}
                      showCurrentYearOnly={true}
                      schoolid={schoolid}
                    />
                  </Col>
                  <Link to="/beforescreening">
                    <button
                      style={buttonStyle}
                      // onClick={handleShowModal}
                      onMouseEnter={(e) => {
                        // No hover effect - maintain same style
                        e.target.style.backgroundColor = '#FF6B35';
                      }}
                      onMouseLeave={(e) => {
                        // No hover effect - maintain same style
                        e.target.style.backgroundColor = '#FF6B35';
                      }}
                      onFocus={(e) => {
                        // No focus effect - maintain same style
                        e.target.style.outline = 'none';
                      }}
                    >
                      Show these videos in class before screening and review word & image list for AEN and EAL
                    </button>
                  </Link>

                  {/* <VideoModal
                      buttonText="📺 Click here to see Hints & Tips For Screening"
                      modalTitle="Hints & Tips For Screening"
                      videos={[
                        {
                          title: "Hints & Tips For Screening",
                          iframe: "https://www.youtube.com/embed/wQIKM3UAQww?si=-B-a2654zZKOuTv1"
                        }
                      ]}
                    /> */}

                </Row>
                <Row className="row-position-assessment">
                  {!isPilot && !isTrialActive ? (
                    <Col className="text-center">
                      <div className="alert alert-info mt-4">
                        Your trial hasn't started yet. Please select a start
                        date to begin your ALPACA experience.
                      </div>
                    </Col>
                  ) : isAccessRestricted ? (
                    <Col className="text-center">
                      <div className="alert alert-warning mt-4">
                        Your free trial has ended. To continue accessing
                        ALPACA's features, please consider purchasing a
                        subscription.
                      </div>
                    </Col>
                  ) : filteredClasses.length === 0 ? (
                    <AlpacaInfoGesture speechText={speechText} />
                  ) : (
                    filteredClasses.map((item, index) => (
                      <AssessmentClassCard
                        key={`${item.id}-${index}`}
                        teachers={teachers}
                        classDetails={item}
                        rollNumber={rollNumber}
                        gradeLevelOptions={gradeLevelOptions}
                        teacherid={teacherid}
                        schoolid={schoolid}
                        countryId={countryId}
                        isJIOnlyTrial={isJIOnlyTrial}
                        isPilot={isPilot}
                        latestPurchase={latestPurchase}
                        purchaseAccessError={purchaseError}
                      />
                    ))
                  )}
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Container>
      {isPortrait && <OrientationPrompt />}

      {/* Modal for selecting trial start date */}
      <Modal
        show={showStartTrialModal}
        onHide={() => setShowStartTrialModal(false)}
        aria-labelledby="trial-modal-title"
        aria-describedby="trial-modal-description"
      >
        <Modal.Header closeButton>
          <Modal.Title id="trial-modal-title">Start Your Free Trial</Modal.Title>
        </Modal.Header>
        <Modal.Body id="trial-modal-description">
          {/* Display Start Date Information */}
          {start_selected ? (
            <p>
              Your trial is set to start on:{" "}
              <strong>{start_date ? format(new Date(start_date), "dd/MM/yyyy") : "Not set"}</strong>.
            </p>
          ) : (
            <div className="alert alert-warning">
              You have not yet selected a start date for your trial.
            </div>
          )}

          {/* Date Picker */}
          <p>Select a date to start your free trial:</p>
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            className="form-control"
            dateFormat="dd/MM/yyyy" // Irish date format
            minDate={new Date()} // Prevent past dates
          />
        </Modal.Body>
        <Modal.Footer>
          {/* Button to Start Now */}
          <Button
            variant="success"
            onClick={async () => {
              try {
                const now = new Date();
                await updateTrialistStartDate(schoolid, now.toISOString());
                setSelectedDate(now);
                setShowStartTrialModal(false);
                alert("Trial start date set to now!");
                window.location.reload();
              } catch (error) {
                console.error("Error setting trial start date to now:", error);
              }
            }}
          >
            Start Now
          </Button>

          {/* Button to Confirm Selected Date */}
          <Button
            variant="primary"
            onClick={async () => {
              try {
                await updateTrialistStartDate(schoolid, selectedDate.toISOString());
                setShowStartTrialModal(false);
                alert("Trial start date has been updated.");
                window.location.reload();
              } catch (error) {
                console.error("Error setting trial start date:", error);
              }
            }}
          >
            Confirm Start Date
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AssessmentsDashboard;
